import axios from 'axios';
import normalize from 'Utils/normalizer';
import { map, omitBy, isEmpty, isNil, omit, unset, forEach } from 'lodash';
import { errorHandler } from '../utils';

interface emailBody {};

export const sendEmailCorporate = async (payload: emailBody) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/dem/mail/send/corporate`;

  try {
    const res = await axios({
      method: 'POST',
      url: url,
      data: payload
    });
    if (res?.data?.send) { return true }
  }
  catch(err) {
    return false
  }
}

interface CancelOrderPayload {
  fullName: string;
  bankName: string;
  bankAccNumber: string;
  orderNumber: string;
  productName: string;
  reason: string;
}

export const sendCancelOrderEmail = async (data: CancelOrderPayload) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/dem/mail/send/cancel`;
  const productList = data.productName.split(",");
  let products: any = []

  forEach(productList, product => {
    products.push({
      name: product
    })
  })
  
  if (data.productName) {
    unset(data, 'productName');
  }

  try {
    const res = await axios({
      method: 'POST',
      url: url,
      data: { ...data, products }
    });

    if (res?.data?.send) { 
      return true 
    }
  }
  catch(err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await sendCancelOrderEmail(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    }
    else {
      console.log(err.message)
      return { error: { message: err.message } };
    }
  }
}